import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {HttpService} from './http.service';

@Injectable()
export class ProjectsApi {

    private readonly apiController: string = '/api/projects';
    private readonly apiBulkController: string = '/api/bulkProjects';

    constructor(private api: HttpService) {
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string, scope: boolean): Observable<any[]> {
        const params = new HttpParams()
            .set('page', `${pageNumber}`)
            .set('pageSize', `${pageSize}`)
            .set('search', `${search}`)
            .set('order', `${orderBy}`)
            .set('scope', `${scope}`);

        return this.api.get(this.apiController, {params}).pipe(map((data) => data));
    }

    get(id: number, cloudId: number): Observable<any> {
        return this.api.get(`${this.apiController}/${id}`)
            .pipe(map(data => {
                return {...data};
            }));
    }


    add(item: any): Observable<any> {
        // Asegurar que el item tenga los campos de código separados
        const payload = {
            ...item,
            codigo_padre: item.codigo_padre !== undefined ? item.codigo_padre : '',
            codigo_glosa: item.codigo_glosa !== undefined ? item.codigo_glosa : '',
            codigo_lista: item.codigo_lista !== undefined ? item.codigo_lista : ''
        };
        
        console.log('ProjectsApi.add - Payload final que se envía:', JSON.stringify(payload, null, 2));
        
        return this.api.post(`${this.apiController}`, payload);
    }

    update(item: any): Observable<any> {
        // Asegurar que el item se serialice correctamente
        // Si es un array, asegurar que todos los elementos tengan los campos necesarios
        const payload = Array.isArray(item) ? item.map(i => ({
            ...i,
            codigo_padre: i.codigo_padre !== undefined ? i.codigo_padre : '',
            codigo_glosa: i.codigo_glosa !== undefined ? i.codigo_glosa : '',
            codigo_lista: i.codigo_lista !== undefined ? i.codigo_lista : ''
        })) : {
            ...item,
            codigo_padre: item.codigo_padre !== undefined ? item.codigo_padre : '',
            codigo_glosa: item.codigo_glosa !== undefined ? item.codigo_glosa : '',
            codigo_lista: item.codigo_lista !== undefined ? item.codigo_lista : ''
        };
        
        console.log('ProjectsApi.update - Payload final que se envía:', JSON.stringify(payload, null, 2));
        
        return this.api.put(`${this.apiController}`, payload);
    }

    delete(item: any): Observable<any> {
        return this.api.delete(`${this.apiController}/${item.ID}`, item);
    }

    bulk(item: any): Observable<any> {
        return this.api.post(`${this.apiBulkController}`, item);
    }

}
